import { createFileRoute } from "@tanstack/react-router";
import { EnrichmentTab } from "./settings.catalog";

export const Route = createFileRoute("/settings/catalog/enrichment")({
	component: EnrichmentTab,
});
